import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function FiltroEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, Gjahr, Bukrs, Vkorg) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/FiltroEstadoCuenta";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Gjahr': Gjahr,
        'dto.Bukrs': Bukrs,
        'dto.VKorg': Vkorg,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function BuscarEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, Gjahr, Monat, Bukrs, Vkorg) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarEstadoCuenta";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Gjahr': Gjahr,
        'dto.Monat': Monat,
        'dto.Bukrs': Bukrs,
        'dto.VKorg': Vkorg,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function PdfEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, Gjahr, Bukrs, Vkorg, Monat) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/PdfEstadoCuenta";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Gjahr': Gjahr,
        'dto.Bukrs': Bukrs,
        'dto.VKorg': Vkorg,
        'dto.Monat': Monat,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}